import { render, staticRenderFns } from "./couponGoodsList.vue?vue&type=template&id=a3b619fa&scoped=true"
import script from "./couponGoodsList.vue?vue&type=script&lang=js"
export * from "./couponGoodsList.vue?vue&type=script&lang=js"
import style0 from "./couponGoodsList.vue?vue&type=style&index=0&id=a3b619fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b619fa",
  null
  
)

export default component.exports